import BillsOutlined from "assets/icons/Bills-Outlined.svg";
import ManualJournalOutlined from "assets/icons/ManualJornal-Outlined.svg";
import ReportsOutlined from "assets/icons/Reports-Outlined.svg";
import CustomersOutlined from "assets/icons/Customers-Outlined.svg";
import ProductsOutlined from "assets/icons/Products-Outlined.svg";
import TasksOutlined from "assets/icons/Tasks-Outlined.svg";
import CustomerReceiptsOutlined from "assets/icons/Cutsomer Receipts-Outlined.svg";
import ProjectsOutlined from "assets/icons/Projects-Outlined.svg";
import VendorReceiptsOutlined from "assets/icons/Vendor Receipts-Outlined.svg";
import FolderOpenOutlined from "assets/icons/FolderOpen-r.svg";
import DimensionSettingsOutlined from "assets/icons/dimension_settings.svg";
import PurchasesOrdersOutlined from "assets/icons/Purchases Orders.svg";
import VendorsOutlined from "assets/icons/Vendors-Outlined.svg";
import InvoiceOutlined from "assets/icons/Inovice-Outlined.svg";
import QuotationsOutlined from "assets/icons/Quotations-Outlined.svg";
import DeductionOutlined from "assets/icons/Deductions-Outlined.svg";
import LoanOutlined from "assets/icons/Loan-Outlined.svg";
import SoundOutlined from "assets/icons/SoundOutlined.svg";
import QFill from "assets/icons/qFilled.svg";
import DisposalOutlined from "assets/icons/disposal.svg";
import Budgeting from "assets/icons/Budgeting-icon.svg";
import CurrencyIcon from "assets/icons/currencyMenu.svg";
import Q_Academy from "assets/icons/Q_Academy.svg";
import Cleanup from "assets/icons/Cleanup.svg";
import Training from "assets/icons/Training.svg";
import ConsultationService from "assets/icons/ConsultationService.svg";
import SetupServices from "assets/icons/Setup_Service.svg";
import InvoiceDesign from "assets/icons/InvoiceDesign.svg";
import BalanceEntries from "assets/icons/BalanceEntries.svg";
import TradferAccountsIcon from "assets/icons/TransferAccountsIcon.svg";
import VAT_Service from "assets/icons/VAT_Service.svg";
import FixedAssetAdditionIcon from "assets/icons/FixedAssetAddition.svg";
import CreditNoteOutlined from "assets/icons/CreditNote-Outlined.svg";
import DebittNoteOutlined from "assets/icons/DebittNote-Outlined.svg";
// The percent badge from NSBH's own wordmark, redrawn as a 16px monochrome
// glyph so it follows the sidebar theme. The wordmark PNG itself is wide and
// white-only, so it cannot serve as an icon.
import NsbhOutlined from "assets/icons/nsbh.svg";

import {
  BankOutlined,
  DashboardOutlined,
  DollarOutlined,
  TableOutlined,
  SettingOutlined,
  RocketOutlined,
  UserOutlined,
  FileProtectOutlined,
  FileAddOutlined,
  EditOutlined,
  PaperClipOutlined,
  QuestionCircleOutlined,
  EnvironmentOutlined,
  InsertRowBelowOutlined,
  FallOutlined,
  ToolOutlined,
  BarChartOutlined,
  ApartmentOutlined,
  GiftOutlined,
  SyncOutlined,
  FileDoneOutlined,
  TagOutlined,
  UsergroupAddOutlined,
  CalendarOutlined,
  FileTextOutlined,
  TagsOutlined,
  SwapOutlined,
  ColumnHeightOutlined,
  ReconciliationOutlined,
  ImportOutlined,
  ExportOutlined,
  FolderOutlined,
  BookOutlined,
  CarOutlined,
  IdcardOutlined,
  FileSearchOutlined,
  ApiOutlined,
} from "@ant-design/icons";
import QIcon from "components/layout/QIcon";

export const iconMap = new Map<string, React.ReactNode>([
  ["sidepanel_dashboards", <DashboardOutlined key="ICON" />],
  ["sidepanel_advanced_accounting_portal", <DashboardOutlined key="ICON" />],
  ["sidepanel_sales", <DollarOutlined key="ICON" />],
  ["sidepanel_sales__customers", <QIcon key="ICON" component={CustomersOutlined} />],
  ["sidepanel_sales__quotations", <QIcon key="ICON" component={QuotationsOutlined} />],
  ["sidepanel_sales__invoices", <QIcon key="ICON" component={InvoiceOutlined} />],
  ["sidepanel_sales__credit_notes", <QIcon key="ICON" component={CreditNoteOutlined} />],
  ["sidepanel_sales__sales_debit_notes", <QIcon key="ICON" component={DebittNoteOutlined} />],
  ["sidepanel_sales__customer_receipts", <QIcon key="ICON" component={CustomerReceiptsOutlined} />],
  ["sidepanel_sales__get_paid", <QIcon key="ICON" component={InvoiceOutlined} />],
  ["sidepanel_purchases", <QIcon key="ICON" component={PurchasesOrdersOutlined} />],
  ["sidepanel_purchases__vendors", <QIcon key="ICON" component={VendorsOutlined} />],
  [
    "sidepanel_purchases__purchase_orders",
    <QIcon key="ICON" component={PurchasesOrdersOutlined} />,
  ],
  ["sidepanel_purchases__bills", <QIcon key="ICON" component={BillsOutlined} />],
  ["sidepanel_purchases__debit_notes", <QIcon key="ICON" component={DebittNoteOutlined} />],
  ["sidepanel_purchases__simple_bills", <QIcon key="ICON" component={BillsOutlined} />],
  [
    "sidepanel_purchases__simple_bill_debit_notes",
    <QIcon key="ICON" component={DebittNoteOutlined} />,
  ],
  ["sidepanel_purchases__vendor_receipts", <QIcon key="ICON" component={VendorReceiptsOutlined} />],
  ["sidepanel_expense_claims", <FileTextOutlined key="ICON" />],
  ["sidepanel_expense_claims__list", <FileTextOutlined key="ICON" />],
  ["sidepanel_expense_claims__types", <TagsOutlined key="ICON" />],
  ["sidepanel_purchase_requests", <FileTextOutlined key="ICON" />],
  ["sidepanel_purchase_requests__list", <FileTextOutlined key="ICON" />],
  ["sidepanel_purchase_requests__rfqs", <FileSearchOutlined key="ICON" />],
  ["sidepanel_delivery_orders", <CarOutlined key="ICON" />],
  ["sidepanel_delivery_orders__list", <CarOutlined key="ICON" />],
  ["sidepanel_drivers__list", <IdcardOutlined key="ICON" />],
  ["sidepanel_dispatch__list", <CarOutlined key="ICON" />],
  ["sidepanel_products", <QIcon key="ICON" component={ProductsOutlined} />],
  ["sidepanel_products__products", <QIcon key="ICON" component={ProductsOutlined} />],
  ["sidepanel_products__inventories", <EnvironmentOutlined key="ICON" />],
  ["sidepanel_products__productions", <InsertRowBelowOutlined key="ICON" />],
  [
    "sidepanel_products__product_attribute_reclassifications",
    <ReconciliationOutlined key="ICON" />,
  ],
  ["sidepanel_products__inventory_transfers", <SwapOutlined key="ICON" />],
  ["sidepanel_products__categories", <TagsOutlined key="ICON" />],
  ["sidepanel_products__unit_types", <ColumnHeightOutlined key="ICON" />],
  ["sidepanel_products__stock_takes", <ReconciliationOutlined key="ICON" />],
  ["sidepanel_fixed_assets", <TableOutlined key="ICON" />],
  ["sidepanel_fixed_assets__fixed_assets", <TableOutlined key="ICON" />],
  ["sidepanel_fixed_assets__depreciations", <FallOutlined key="ICON" />],
  ["sidepanel_fixed_assets__disposals", <QIcon key="ICON" component={DisposalOutlined} />],
  [
    "sidepanel_fixed_assets__additions",
    <QIcon component={FixedAssetAdditionIcon} style={{ fontSize: "20px" }} />,
  ],
  ["sidepanel_fixed_assets__asset_classifications", <FolderOutlined key="ICON" />],
  ["sidepanel_fixed_assets__asset_transfers", <SwapOutlined key="ICON" />],
  ["sidepanel_fixed_assets__asset_expenses", <DollarOutlined key="ICON" />],
  ["sidepanel_fixed_assets__import", <ImportOutlined key="ICON" />],
  ["sidepanel_fixed_assets__export", <ExportOutlined key="ICON" />],
  ["sidepanel_payrolls", <QIcon key="ICON" component={FolderOpenOutlined} />],
  ["sidepanel_payrolls__payroll_activate", <ToolOutlined key="ICON" />],
  ["sidepanel_payrolls__onboarding_hr", <QIcon key="ICON" component={SoundOutlined} />],
  ["sidepanel_payrolls__qhr", <ApiOutlined key="ICON" />],
  ["sidepanel_payrolls__employees", <QIcon key="ICON" component={CustomersOutlined} />],
  ["sidepanel_payrolls__payrolls", <QIcon key="ICON" component={FolderOpenOutlined} />],
  ["sidepanel_payrolls__loans", <QIcon key="ICON" component={LoanOutlined} />],
  ["sidepanel_payrolls__bonuses", <GiftOutlined key="ICON" />],
  ["sidepanel_payrolls__deductions", <QIcon key="ICON" component={DeductionOutlined} />],
  ["sidepanel_accounting", <QIcon key="ICON" component={FolderOpenOutlined} />],
  ["sidepanel_accounting__easy_entries", <QIcon key="ICON" component={ManualJournalOutlined} />],
  [
    "sidepanel_accounting__manual_journal_entries",
    <QIcon key="ICON" component={ManualJournalOutlined} />,
  ],
  ["sidepanel_accounting__accounts", <BarChartOutlined key="ICON" />],
  ["sidepanel_accounting__audit_processes", <ApartmentOutlined key="ICON" />],
  ["sidepanel_accounting__budgets", <QIcon key="ICON" component={Budgeting} />],
  ["sidepanel_accounting__deferral_templates", <QIcon key="ICON" component={Budgeting} />],
  ["sidepanel_accounting__opening_balances", <BookOutlined key="ICON" />],
  ["sidepanel_accounting__import_mjes", <ImportOutlined key="ICON" />],
  ["sidepanel_settings__pricing_discount_schemas", <QIcon key="ICON" component={Budgeting} />],
  ["sidepanel_sales__sales_pricing_discount_schemas", <QIcon key="ICON" component={Budgeting} />],
  [
    "sidepanel_purchases__purchases_pricing_discount_schemas",
    <QIcon key="ICON" component={Budgeting} />,
  ],
  ["sidepanel_accounting__commercial_document", <QIcon key="ICON" component={InvoiceOutlined} />],
  ["sidepanel_accounting__recurring_transactions", <SyncOutlined key="ICON" />],
  ["sidepanel_projects_tasks", <QIcon key="ICON" component={TasksOutlined} />],
  ["sidepanel_projects_tasks__projects", <QIcon key="ICON" component={ProjectsOutlined} />],
  ["sidepanel_projects_tasks__tasks", <QIcon key="ICON" component={TasksOutlined} />],
  ["sidepanel_reports", <QIcon key="ICON" component={ReportsOutlined} />],
  ["sidepanel_reports__reports", <QIcon key="ICON" component={UsergroupAddOutlined} />],
  ["sidepanel_reports__report_status", <QIcon key="ICON" component={CalendarOutlined} />],
  ["sidepanel_qoyod_services", <QIcon key="ICON" component={QFill} />],
  [
    "sidepanel_qoyod_services__consultation_service",
    <QIcon key="ICON" component={ConsultationService} />,
  ],
  ["sidepanel_qoyod_services__setup", <QIcon key="ICON" component={SetupServices} />],
  ["sidepanel_qoyod_services__invoice_design", <QIcon key="ICON" component={InvoiceDesign} />],
  ["sidepanel_qoyod_services__balance_entries", <QIcon key="ICON" component={BalanceEntries} />],
  ["sidepanel_qoyod_services__qoyod_academy", <QIcon key="ICON" component={Q_Academy} />],
  [
    "sidepanel_qoyod_services__transfer_accounts",
    <QIcon key="ICON" component={TradferAccountsIcon} />,
  ],
  ["sidepanel_qoyod_services__bookkeeping", <QIcon key="ICON" component={QFill} />],
  ["sidepanel_qoyod_services__cleanup", <QIcon key="ICON" component={Cleanup} />],
  ["sidepanel_qoyod_services__training", <QIcon key="ICON" component={Training} />],
  ["sidepanel_qoyod_services__vat", <QIcon key="ICON" component={VAT_Service} />],
  ["sidepanel_settings", <SettingOutlined key="ICON" />],
  ["sidepanel_settings__general_settings", <SettingOutlined key="ICON" />],
  ["sidepanel_settings__dimensions", <QIcon key="ICON" component={DimensionSettingsOutlined} />],
  ["sidepanel_settings__manage_subscriptions", <SettingOutlined key="ICON" />],
  ["sidepanel_settings__fiscal_years", <FileDoneOutlined key="ICON" />],
  ["sidepanel_settings__billing_info", <SettingOutlined key="ICON" />],
  ["sidepanel_settings__integrations", <RocketOutlined key="ICON" />],
  ["sidepanel_settings__taxes", <SettingOutlined key="ICON" />],
  ["sidepanel_settings__payroll_settings", <SettingOutlined key="ICON" />],
  ["sidepanel_settings__users", <UserOutlined key="ICON" />],
  ["sidepanel_settings__payment_terms", <FileProtectOutlined key="ICON" />],
  ["sidepanel_settings__custom_fields", <FileAddOutlined key="ICON" />],
  ["sidepanel_settings__edit_profile", <EditOutlined key="ICON" />],
  ["sidepanel_settings__attachments", <PaperClipOutlined key="ICON" />],
  ["sidepanel_settings__product_attributes", <TagOutlined key="ICON" />],
  ["sidepanel_show_me_how", <QuestionCircleOutlined key="ICON" />],
  ["sidepanel_knowledge_base", <QuestionCircleOutlined key="ICON" />],
  ["sidepanel_web_pos", <QIcon key="ICON" component={QFill} />],
  ["sidepanel_qlend", <QIcon key="ICON" component={QFill} />],
  ["sidepanel_financial_solutions", <BankOutlined key="ICON" />],
  ["sidepanel_financial_solutions__nsbh", <QIcon key="ICON" component={NsbhOutlined} />],
  ["sidepanel_qtahseel", <QIcon key="ICON" component={QFill} />],
  ["sidepanel_settings__currencies", <QIcon key="ICON" component={CurrencyIcon} />],
  ["sidepanel_customer_portal_demo", <QIcon key="ICON" component={CustomersOutlined} />],
  ["sidepanel_settings__commissions", <QIcon key="ICON" component={QFill} />],
  ["sidepanel_settings__workflow_board", <ApartmentOutlined key="ICON" />],
  // QERP re-homes these Settings pages into their working module (see QerpSidePanelHelper).
  ["sidepanel_accounting__fiscal_years", <FileDoneOutlined key="ICON" />],
  ["sidepanel_accounting__taxes", <SettingOutlined key="ICON" />],
  ["sidepanel_accounting__currencies", <QIcon key="ICON" component={CurrencyIcon} />],
  ["sidepanel_sales__commissions", <QIcon key="ICON" component={QFill} />],
  ["sidepanel_products__product_attributes", <TagOutlined key="ICON" />],
  ["sidepanel_settings__workflow_templates", <FileDoneOutlined key="ICON" />],
  ["sidepanel_settings__workflow_assignments", <UserOutlined key="ICON" />],
]);

export const labelMap = new Map<string, string>([
  ["sidepanel_dashboards", "activerecord.attributes.layout.dashboard"],
  [
    "sidepanel_advanced_accounting_portal",
    "activerecord.attributes.side_menu.advanced_accountant_portal",
  ],
  ["sidepanel_sales", "activerecord.attributes.layout.sales"],
  ["sidepanel_sales__customers", "activerecord.attributes.layout.customers"],
  ["sidepanel_sales__quotations", "activerecord.attributes.layout.quotations"],
  ["sidepanel_sales__invoices", "activerecord.attributes.layout.invoices"],
  ["sidepanel_sales__credit_notes", "activerecord.attributes.layout.credit_notes"],
  ["sidepanel_sales__sales_debit_notes", "activerecord.external_documents.sales_debit_note.title"],
  ["sidepanel_sales__customer_receipts", "activerecord.attributes.layout.customer_receipts"],
  ["sidepanel_sales__ar_command_center", "cc.nav_title"],
  ["sidepanel_sales__get_paid", "activerecord.attributes.layout.get_paid_dashboard"],
  ["sidepanel_purchases", "activerecord.attributes.layout.purchases"],
  ["sidepanel_purchases__vendors", "activerecord.attributes.layout.vendors"],
  ["sidepanel_purchases__purchase_orders", "activerecord.attributes.layout.orders"],
  ["sidepanel_purchases__bills", "activerecord.attributes.layout.bills"],
  ["sidepanel_purchases__debit_notes", "activerecord.attributes.layout.debit_notes"],
  ["sidepanel_purchases__simple_bills", "activerecord.attributes.layout.simple_bills"],
  [
    "sidepanel_purchases__simple_bill_debit_notes",
    "activerecord.external_documents.simple_bill_debit_note.title",
  ],
  ["sidepanel_purchases__vendor_receipts", "activerecord.attributes.layout.vendor_receipts"],
  ["sidepanel_expense_claims", "expense_claim.nav"],
  ["sidepanel_expense_claims__list", "expense_claim.nav_list"],
  ["sidepanel_expense_claims__types", "expense_type.nav"],
  ["sidepanel_purchase_requests", "requisition.nav"],
  ["sidepanel_purchase_requests__list", "purchase_request.nav_list"],
  ["sidepanel_purchase_requests__rfqs", "rfq.nav"],
  ["sidepanel_delivery_orders", "delivery_order.nav"],
  ["sidepanel_delivery_orders__list", "delivery_order.nav_list"],
  ["sidepanel_drivers__list", "driver.nav_list"],
  ["sidepanel_dispatch__list", "delivery_order.dispatch.nav_list"],
  ["sidepanel_products", "activerecord.attributes.layout.products"],
  ["sidepanel_products__products", "activerecord.attributes.layout.products"],
  ["sidepanel_products__inventories", "activerecord.attributes.layout.locations"],
  ["sidepanel_products__productions", "activerecord.attributes.layout.productions"],
  [
    "sidepanel_products__product_attribute_reclassifications",
    "product_attribute_reclassification.button.title",
  ],
  ["sidepanel_products__inventory_transfers", "activerecord.attributes.product.inventory_transfer"],
  ["sidepanel_products__categories", "forms.buttons.product_categories"],
  ["sidepanel_products__unit_types", "forms.buttons.unit_types"],
  ["sidepanel_products__stock_takes", "activerecord.attributes.product.stock_take"],
  ["sidepanel_fixed_assets", "activerecord.attributes.layout.fixed_assets"],
  ["sidepanel_fixed_assets__fixed_assets", "activerecord.attributes.layout.fixed_assets"],
  ["sidepanel_fixed_assets__depreciations", "activerecord.attributes.fixed_asset.depreciation"],
  ["sidepanel_fixed_assets__disposals", "activerecord.attributes.tenant_role.disposals"],
  ["sidepanel_fixed_assets__additions", "fixed_asset_additions.layout.title"],
  [
    "sidepanel_fixed_assets__asset_classifications",
    "activerecord.attributes.fixed_asset.asset_classifications",
  ],
  ["sidepanel_fixed_assets__asset_transfers", "activerecord.attributes.fixed_asset.asset_transfer"],
  ["sidepanel_fixed_assets__asset_expenses", "asset_expenses.layout.title"],
  ["sidepanel_fixed_assets__import", "activerecord.attributes.fixed_asset.import"],
  ["sidepanel_fixed_assets__export", "activerecord.attributes.fixed_asset.export"],
  ["sidepanel_payrolls", "activerecord.attributes.layout.human_resources"],
  ["sidepanel_payrolls__payroll_activate", "activerecord.attributes.layout.onboarding.activate"],
  ["sidepanel_payrolls__onboarding_hr", "activerecord.attributes.layout.onboarding.onboarding"],
  ["sidepanel_payrolls__qhr", "qhr.settings.title"],
  ["sidepanel_payrolls__employees", "activerecord.attributes.layout.employees"],
  ["sidepanel_payrolls__payrolls", "activerecord.attributes.layout.payrolls"],
  ["sidepanel_payrolls__loans", "activerecord.attributes.layout.loans"],
  ["sidepanel_payrolls__bonuses", "activerecord.attributes.layout.bonuses"],
  ["sidepanel_payrolls__deductions", "activerecord.attributes.layout.deductions"],
  ["sidepanel_accounting", "activerecord.attributes.layout.accounting"],
  ["sidepanel_accounting__easy_entries", "activerecord.attributes.layout.easy_entries"],
  [
    "sidepanel_accounting__manual_journal_entries",
    "activerecord.attributes.layout.manual_journal_entries",
  ],
  ["sidepanel_accounting__accounts", "activerecord.attributes.layout.chart_of_accounts"],
  ["sidepanel_accounting__audit_processes", "audit_process.menu"],
  ["sidepanel_accounting__budgets", "budgets.name"],
  ["sidepanel_accounting__deferral_templates", "deferral.name"],
  [
    "sidepanel_accounting__opening_balances",
    "activerecord.attributes.layout.opening_balances.opening_balances",
  ],
  ["sidepanel_accounting__import_mjes", "activerecord.attributes.manual_journal_entries.import"],
  ["sidepanel_settings__pricing_discount_schemas", "pricing_discount_schema.title"],
  ["sidepanel_sales__sales_pricing_discount_schemas", "qerp.labels.sales_pricing_discount_schema"],
  [
    "sidepanel_purchases__purchases_pricing_discount_schemas",
    "qerp.labels.purchases_pricing_discount_schema",
  ],
  ["sidepanel_accounting__commercial_document", "commercial_documents.title"],
  ["sidepanel_accounting__recurring_transactions", "recurring_transactions.title"],
  ["sidepanel_projects_tasks", "templates.project_and_task"],
  ["sidepanel_projects_tasks__projects", "templates.projects.projects"],
  ["sidepanel_projects_tasks__tasks", "templates.tasks.tasks"],
  ["sidepanel_reports", "activerecord.attributes.layout.reports"],
  ["sidepanel_reports__reports", "activerecord.attributes.layout.all_reports"],
  ["sidepanel_reports__report_status", "activerecord.attributes.layout.report_status"],
  ["sidepanel_qoyod_services", "activerecord.attributes.layout.professional_services"],
  ["sidepanel_qoyod_services__setup", "activerecord.attributes.layout.setup_service"],
  ["sidepanel_qoyod_services__invoice_design", "activerecord.attributes.layout.invoice_design"],
  ["sidepanel_qoyod_services__balance_entries", "activerecord.attributes.layout.balance_entries"],
  [
    "sidepanel_qoyod_services__transfer_accounts",
    "activerecord.attributes.layout.transfer_accounts",
  ],
  ["sidepanel_qoyod_services__qoyod_academy", "activerecord.attributes.layout.qoyod_academy"],
  ["sidepanel_qoyod_services__bookkeeping", "activerecord.attributes.layout.bookkeeping"],
  ["sidepanel_qoyod_services__cleanup", "activerecord.attributes.layout.cleanup_service"],
  ["sidepanel_qoyod_services__training", "activerecord.attributes.layout.training_service"],
  [
    "sidepanel_qoyod_services__consultation_service",
    "activerecord.attributes.layout.consultation_service",
  ],
  ["sidepanel_qoyod_services__vat", "activerecord.attributes.layout.vat_service"],
  ["sidepanel_settings", "activerecord.attributes.layout.settings"],
  ["sidepanel_settings__general_settings", "activerecord.attributes.layout.general_settings"],
  ["sidepanel_settings__dimensions", "activerecord.attributes.dimension.settings"],
  ["sidepanel_settings__fiscal_years", "fiscal_year.title"],
  [
    "sidepanel_settings__manage_subscriptions",
    "activerecord.attributes.layout.manage_subscription_settings",
  ],
  ["sidepanel_settings__billing_info", "activerecord.attributes.layout.billing_details"],
  ["sidepanel_settings__integrations", "templates.integration"],
  ["sidepanel_settings__taxes", "activerecord.attributes.tax.layout.index"],
  [
    "sidepanel_settings__payroll_settings",
    "activerecord.attributes.layout.human_resources_settings",
  ],
  ["sidepanel_settings__users", "activerecord.attributes.layout.users"],
  ["sidepanel_settings__payment_terms", "activerecord.attributes.layout.payment_terms"],
  ["sidepanel_settings__custom_fields", "activerecord.attributes.layout.custom_fields"],
  ["sidepanel_settings__edit_profile", "activerecord.attributes.layout.edit_profile"],
  ["sidepanel_settings__attachments", "activerecord.attributes.layout.attachments"],
  ["sidepanel_settings__product_attributes", "product_attribute.title"],
  ["sidepanel_show_me_how", "activerecord.attributes.help_content.btn_H"],
  ["sidepanel_knowledge_base", "frontend.tooltips.on_boarding.knowledge_base"],
  ["sidepanel_web_pos", "activerecord.attributes.layout.web_pos"],
  ["sidepanel_qlend", "activerecord.attributes.layout.qoyod_lend"],
  ["sidepanel_financial_solutions", "activerecord.attributes.layout.financial_solutions"],
  ["sidepanel_financial_solutions__nsbh", "financial_solutions.providers.nsbh.name"],
  ["sidepanel_qtahseel", "activerecord.attributes.layout.qoyod_tahseel"],
  ["sidepanel_settings__currencies", "tenant.multi_currencies.title"],
  ["sidepanel_customer_portal_demo", "frontend.tooltips.on_boarding.customer_portal_demo"],
  ["sidepanel_settings__commissions", "commission.title"],
  ["sidepanel_settings__workflow_board", "workflow.board.title"],
  ["sidepanel_settings__workflow_templates", "workflow.templates.title"],
  ["sidepanel_settings__workflow_assignments", "workflow.assignments.title"],
  ["sidepanel_accounting__fiscal_years", "fiscal_year.title"],
  ["sidepanel_accounting__taxes", "activerecord.attributes.tax.layout.index"],
  ["sidepanel_accounting__currencies", "tenant.multi_currencies.title"],
  ["sidepanel_sales__commissions", "commission.title"],
  ["sidepanel_products__product_attributes", "product_attribute.title"],
]);

// QERP-only sidebar label overrides (applied when body has qerp-theme; non-QERP untouched).
export const qerpLabelMap = new Map<string, string>([
  ["sidepanel_products", "qerp.labels.inventory_management"],
  ["sidepanel_purchases__bills", "qerp.labels.purchase_invoices"],
  ["sidepanel_purchases__simple_bills", "qerp.labels.expenses_invoice"],
  ["sidepanel_products__products", "qerp.labels.items"],
  ["sidepanel_products__inventory_transfers", "qerp.labels.stock_transfer"],
  ["sidepanel_products__unit_types", "qerp.labels.unit_of_measure"],
  ["sidepanel_products__stock_takes", "qerp.labels.stock_adjustment"],
  ["sidepanel_accounting__budgets", "qerp.labels.financial_budgets"],
]);

export const quickCreateLabelMap = new Map<string, string>([
  ["sidepanel_sales__customers", "quick_create.customer"],
  ["sidepanel_sales__quotations", "quick_create.quotation"],
  ["sidepanel_sales__invoices", "quick_create.invoice"],
  ["sidepanel_sales__customer_receipts", "quick_create.customer_receipt"],
  ["sidepanel_sales__credit_notes", "quick_create.credit_note"],
  ["sidepanel_purchases__vendors", "quick_create.vendor"],
  ["sidepanel_purchases__debit_notes", "quick_create.debit_note"],
  ["sidepanel_purchases__purchase_orders", "quick_create.purchase_order"],
  ["sidepanel_purchases__bills", "quick_create.bill"],
  ["sidepanel_purchases__simple_bills", "quick_create.simple_bill"],
  ["sidepanel_purchases__simple_bill_debit_notes", "quick_create.simple_bill_debit_note"],
  ["sidepanel_purchases__vendor_receipts", "quick_create.vendor_receipt"],
  ["sidepanel_products__products", "quick_create.product"],
  ["sidepanel_products__inventories", "quick_create.location"],
  ["sidepanel_products__productions", "quick_create.production"],
  ["sidepanel_fixed_assets__fixed_assets", "quick_create.fixed_asset"],
  ["sidepanel_fixed_assets__depreciations", "quick_create.depreciation"],
  ["sidepanel_fixed_assets__disposals", "quick_create.disposal"],
  ["sidepanel_fixed_assets__additions", "quick_create.fixed_asset_addition"],
  ["sidepanel_payrolls__employees", "quick_create.employee"],
  ["sidepanel_payrolls__payrolls", "quick_create.payroll"],
  ["sidepanel_payrolls__loans", "quick_create.loan"],
  ["sidepanel_payrolls__bonuses", "quick_create.bonus"],
  ["sidepanel_payrolls__deductions", "quick_create.deduction"],
  ["sidepanel_accounting__easy_entries", "quick_create.easy_entry"],
  ["sidepanel_accounting__manual_journal_entries", "quick_create.manual_journal_entry"],
  ["sidepanel_accounting__accounts", "quick_create.account"],
  ["sidepanel_accounting__budgets", "quick_create.budget"],
  ["sidepanel_accounting__audit_processes", "quick_create.audit_process"],
  ["sidepanel_accounting__recurring_transactions", "quick_create.recurring_transaction"],
  ["sidepanel_projects_tasks__projects", "quick_create.project"],
  ["sidepanel_projects_tasks__tasks", "quick_create.task"],
]);

export const tagMap = new Map([
  [
    "beta",
    {
      label: "activerecord.attributes.fixed_asset.beta",
      color: "gold",
    },
  ],
  [
    "new",
    {
      label: "status.new",
      color: "orange",
    },
  ],
  [
    "pending",
    {
      label: "status.pending",
      color: "blue",
    },
  ],
  [
    "rejected",
    {
      label: "status.rejected",
      color: "red",
    },
  ],
  [
    "soon",
    {
      label: "status.soon",
      color: "blue",
    },
  ],
  [
    "available",
    {
      label: "status.available",
      color: "green",
    },
  ],
  [
    "demo",
    {
      label: "status.demo",
      color: "blue",
    },
  ],
]);
